import React from 'react';
import { mapsSet } from './constants/mapsSet';

import ModalPreviewer from '@components/ModalPreviewer/ModalPreviewer';
import { ShowCase, Preview, Controls } from '@components/ShowCase';

import styles from './Maps.css';

const Maps = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          mapsSet.map((mapsPreview, i) => (
            <li key={`maps-showcase-${i}`}>
              <ShowCase codeTemplate={mapsPreview.codeTemplate}>
                <Preview className={styles.preview}>
                  <ModalPreviewer
                    previewText="Preview Map"
                    imagePath={`maps/${mapsPreview.imagePath}`}
                  >
                    {mapsPreview.component}
                  </ModalPreviewer>
                </Preview>
                <Controls optionsGroup={mapsPreview.optionsGroup} />
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Maps;



// WEBPACK FOOTER //
// ./src/containers/components/Map/Maps.js